import {getDriverWaterRound} from '../../api/endpoints/driverWaterRounds';

export const state = {
  data: [],
  total: 1,
}

export const getters = {
  items(state) {
    return state.data;
  },
  total(state) {
    return state.total
  }
}

export const mutations = {
  GET_DATA(state, payload) {
    state.data = payload.data;
    state.total = payload.total
  }
}

export const actions = {
  fetchData({commit}, params) {
    return new Promise( (resolve, reject) => {
      getDriverWaterRound(params).then( res => {
        commit('GET_DATA', res.data);
        resolve(res);
      }).catch( err => {
        reject(err);
      })
    })
  }
}